import { render, staticRenderFns } from "./CallEditModal.vue?vue&type=template&id=28807bfe&scoped=true"
import script from "./CallEditModal.vue?vue&type=script&lang=js"
export * from "./CallEditModal.vue?vue&type=script&lang=js"
import style0 from "./CallEditModal.vue?vue&type=style&index=0&id=28807bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28807bfe",
  null
  
)

export default component.exports